function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaybills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m104 360a24 24 0 1 0 24 24 24.028 24.028 0 0 0 -24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1 -8 8z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 360a24 24 0 1 0 24 24 24.028 24.028 0 0 0 -24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1 -8 8z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476 80h-288a28.031 28.031 0 0 0 -28 28v44h-80a8.019 8.019 0 0 0 -6.95 4.03l-64 112a8.017 8.017 0 0 0 -1.05 3.97v92a28.031 28.031 0 0 0 28 28h20.68a47.99 47.99 0 0 0 94.64 0h217.36a47.99 47.99 0 0 0 94.64 0h12.68a28.031 28.031 0 0 0 28-28v-256a28.031 28.031 0 0 0 -28-28zm-405.07 112h57.07v72h-98.21zm-46.93 112h16a8 8 0 0 1 0 16h-16zm80 112a32 32 0 1 1 32-32 32.042 32.042 0 0 1 -32 32zm56-40h-8.68a47.99 47.99 0 0 0 -94.64 0h-20.68a12.01 12.01 0 0 1 -12-12v-28h16a24 24 0 0 0 0-48h-16v-8h112a8 8 0 0 0 8-8v-88a8 8 0 0 0 -8-8h-55.93l4.57-8h75.36zm256 40a32 32 0 1 1 32-32 32.042 32.042 0 0 1 -32 32zm72-52a12.01 12.01 0 0 1 -12 12h-12.68a47.99 47.99 0 0 0 -94.64 0h-192.68v-56h312zm0-60h-312v-196a12.01 12.01 0 0 1 12-12h288a12.01 12.01 0 0 1 12 12z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaybills);
export default __webpack_public_path__ + "static/media/waybills.525dc53442459530de1f51633a8d88ef.svg";
export { ForwardRef as ReactComponent };